import React from 'react';
import { Pause, Play, XCircle, AlertTriangle } from 'lucide-react';
import { campaignStatus, summarize } from '../utils/campaigns';

// Campañas lanzadas: avance, pausar/reanudar/cancelar y mensajes que no salieron. El envío lo hace n8n aunque esta pestaña se cierre.
export default function CampaignHistory({ campaigns, messages, missing, onStatus }) {
  if (missing) {
    return (
      <div className="bg-seryi-bg border border-amber-500/30 p-5 rounded-3xl text-xs text-amber-300" role="status">
        Falta ejecutar la migración <strong>20261019a_campaigns.sql</strong> en Supabase para enviar campañas desde el servidor.
      </div>
    );
  }
  if (!campaigns.length) return null;
  return (
    <div className="bg-seryi-bg border border-seryi-bg-light p-5 rounded-3xl shadow-xl space-y-4" aria-label="Campañas lanzadas">
      <h3 className="text-sm font-black text-seryi-heading">Campañas lanzadas</h3>
      {campaigns.map((c) => {
        const s = summarize(c, messages);
        const st = campaignStatus(c.status);
        const failed = (messages || []).filter((m) => m.campaign_id === c.id && m.status === 'error');
        const open = c.status === 'activa' || c.status === 'pausada';
        return (
          <div key={c.id} className="space-y-2">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <div className="min-w-0">
                <p className="text-sm font-bold text-seryi-heading truncate">{c.name}</p>
                <p className="text-[11px] text-seryi-text">
                  <span className={st.tone}>{st.label}</span> · {s.enviado} de {s.total} enviados
                  {s.pendiente + s.enviando > 0 ? ` · ${s.pendiente + s.enviando} por salir` : ''}
                  {s.error > 0 ? ` · ${s.error} con error` : ''}
                  {s.cancelado > 0 ? ` · ${s.cancelado} cancelados` : ''}
                </p>
              </div>
              {open && (
                <div className="flex items-center gap-2">
                  {c.status === 'activa' ? (
                    <button type="button" onClick={() => onStatus(c.id, 'pausada')} className="flex items-center gap-1.5 px-3 py-2 rounded-xl text-[11px] font-bold bg-seryi-bg-dark border border-seryi-bg-light text-seryi-heading hover:bg-seryi-bg-light">
                      <Pause size={12} /> Pausar
                    </button>
                  ) : (
                    <button type="button" onClick={() => onStatus(c.id, 'activa')} className="flex items-center gap-1.5 px-3 py-2 rounded-xl text-[11px] font-bold bg-seryi-green text-seryi-bg-dark">
                      <Play size={12} /> Reanudar
                    </button>
                  )}
                  <button type="button" onClick={() => { if (window.confirm('¿Cancelar la campaña? Lo que no se haya enviado no saldrá.')) onStatus(c.id, 'cancelada'); }} className="flex items-center gap-1.5 px-3 py-2 rounded-xl text-[11px] font-bold bg-red-600/90 hover:bg-red-500 text-white">
                    <XCircle size={12} /> Cancelar
                  </button>
                </div>
              )}
            </div>
            <div className="w-full bg-seryi-bg-dark rounded-full h-2 overflow-hidden" role="progressbar" aria-valuenow={s.percent} aria-valuemin={0} aria-valuemax={100}>
              <div className={`h-full rounded-full transition-all duration-500 ${c.status === 'pausada' ? 'bg-amber-500' : c.status === 'cancelada' ? 'bg-slate-500' : 'bg-seryi-green'}`} style={{ width: `${s.percent}%` }} />
            </div>
            {failed.length > 0 && (
              <p className="flex items-start gap-1.5 text-[11px] text-rose-300">
                <AlertTriangle size={12} className="mt-0.5 shrink-0" />
                <span>No salieron: {failed.slice(0, 5).map((m) => `${m.customer_name || 'contacto'} (${m.error || 'error'})`).join('; ')}{failed.length > 5 ? ` y ${failed.length - 5} más` : ''}</span>
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
}
